import React__default, { useState, useEffect, useContext } from 'react';
import { StyleSheet, View } from 'react-native';
import { A as AppAssets } from './index-3256db5b.esm.js';
import { A as AppText } from './index-6b88191c.esm.js';
import { _ as _extends } from './extends-a2cb9f0c.esm.js';
import { u as useTheme } from './useTheme-90e8e2c2.esm.js';
import { A as AppFadeView } from './index-948166a0.esm.js';
import { A as AppList } from './index-74f0c7d2.esm.js';

const initialState = {
  state: {},
  dispatch: (a, p) => {}
};
const MenuContext = /*#__PURE__*/React__default.createContext(initialState);
const MenuProvider = _ref => {
  let {
    options,
    subOptions,
    onChange,
    children
  } = _ref;
  const [menuOptions, _setMenuOptions] = useState(options);
  const [menuSubOptions, setMenuSubOptions] = useState(subOptions);
  useEffect(() => {
    _setMenuOptions(options);
  }, [JSON.stringify(options)]);
  const setMenuOptions = value => {
    _setMenuOptions(value);
    onChange && onChange(value);
  };
  return /*#__PURE__*/React__default.createElement(MenuContext.Provider, {
    value: {
      menuOptions,
      menuSubOptions,
      setMenuSubOptions,
      setMenuOptions
    }
  }, children);
};
const useMenu = () => {
  const {
    menuOptions,
    menuSubOptions,
    setMenuSubOptions,
    setMenuOptions
  } = useContext(MenuContext);
  return {
    menuOptions,
    menuSubOptions,
    setMenuSubOptions,
    setMenuOptions
  };
};
MenuProvider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MenuProvider"
};

const DefaultOptionComponent = _ref => {
  var _currentTheme$theme;
  let {
    isNavigation,
    icon,
    onPress,
    children,
    navigationIcon = AppAssets.icons.navigationTo,
    item,
    ...props
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const styles = styleGenerator(currentTheme);
  const emoji = item === null || item === void 0 ? void 0 : item.emoji;
  return /*#__PURE__*/React__default.createElement(AppText, _extends({
    emoji: emoji,
    wrapperStyle: [styles.container],
    style: styles.labelStyle,
    leftIcon: icon || emoji,
    leftIconStyle: emoji && {
      backgroundColor: item.emojiBackgroundColor,
      paddingHorizontal: 15,
      paddingVertical: 5
    },
    iconSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.small_font_size,
    iconHeight: emoji && 20,
    iconWidth: emoji && 40,
    rightIcon: isNavigation && navigationIcon,
    isTextLeftAligned: true,
    isClickable: true,
    onRightIconPress: arg => (item === null || item === void 0 ? void 0 : item.isClickOnIconOnly) === true || isNavigation ? onPress(arg) : () => {},
    onPress: arg => (item === null || item === void 0 ? void 0 : item.isClickOnIconOnly) !== true ? onPress(arg) : () => {}
  }, props), children);
};
const styleGenerator = props => {
  var _props$theme;
  return StyleSheet.create({
    container: {
      padding: 0
    },
    labelStyle: {
      padding: 3,
      fontSize: props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.small_font_size
    }
  });
};
DefaultOptionComponent.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DefaultOptionComponent",
  "props": {
    "navigationIcon": {
      "defaultValue": {
        "value": "Assets.icons.navigationTo",
        "computed": true
      },
      "required": false
    }
  }
};

const DefaultOptionMenuComponent = _ref => {
  var _menuOptions$filter$;
  let {
    children,
    onPress = () => {},
    childrenRenderer,
    originalOption,
    ...props
  } = _ref;
  const {
    handleOptionsChange,
    menuOptions,
    setMenuOptions
  } = useMenu();
  const handleTick = (item, property) => {
    var _menuOptions$idx, _menuOptions$idx2, _menuOptions$idx2$sub, _menuOptions$idx3, _newListData$filter$;
    if (!originalOption) return;
    const idx = menuOptions.map(i => i.uid).indexOf(originalOption.uid);
    const isSingleOption = (_menuOptions$idx = menuOptions[idx]) === null || _menuOptions$idx === void 0 ? void 0 : _menuOptions$idx.isSingleOption;
    let newArray = (_menuOptions$idx2 = menuOptions[idx]) !== null && _menuOptions$idx2 !== void 0 && (_menuOptions$idx2$sub = _menuOptions$idx2.subOptions) !== null && _menuOptions$idx2$sub !== void 0 && _menuOptions$idx2$sub.length ? (_menuOptions$idx3 = menuOptions[idx]) === null || _menuOptions$idx3 === void 0 ? void 0 : _menuOptions$idx3.subOptions : [];
    newArray.map(u => u[property] = isSingleOption && u[property] === true ? false : u[property]);
    const subIdx = newArray.map(si => si.id).indexOf(item.id);
    newArray[subIdx] = {
      ...newArray[subIdx],
      [property]: !newArray[subIdx][property]
    };
    const newObject = {
      ...menuOptions[idx],
      subOptions: newArray
    };
    let newListData = [...menuOptions];
    newListData[idx] = newObject;
    setMenuOptions(newListData);
    const changedItem = (_newListData$filter$ = newListData.filter(opt => (opt === null || opt === void 0 ? void 0 : opt.uid) === (item === null || item === void 0 ? void 0 : item.uid))[0]) === null || _newListData$filter$ === void 0 ? void 0 : _newListData$filter$.subOptions.filter(subOpt => (subOpt === null || subOpt === void 0 ? void 0 : subOpt.id) === (item === null || item === void 0 ? void 0 : item.id))[0];
    onPress(changedItem);
  };
  const listData = (_menuOptions$filter$ = menuOptions.filter(i => (i === null || i === void 0 ? void 0 : i.uid) === (originalOption === null || originalOption === void 0 ? void 0 : originalOption.uid))[0]) === null || _menuOptions$filter$ === void 0 ? void 0 : _menuOptions$filter$.subOptions;
  const child = childrenRenderer({
    handleOptionsChange,
    originalOption,
    menuOptions,
    setMenuOptions,
    handleTick,
    listData
  });
  return /*#__PURE__*/React__default.createElement(View, null, originalOption ? /*#__PURE__*/React__default.cloneElement(child, {
    originalOption
  }) : child);
};
DefaultOptionMenuComponent.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DefaultOptionMenuComponent",
  "props": {
    "onPress": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    }
  }
};

const AppMenuOptions = _ref => {
  let {
    options,
    subOptions,
    OptionComponent = DefaultOptionComponent,
    onOptionPressed,
    onChange = () => {},
    onItemChange = () => {},
    onMainOpened = () => {},
    shouldMenuProvideContext = true,
    isMainMenuBackVisible = true,
    setIsMainMenuBackVisible,
    forcedUIDDisplayed,
    setForcedUIDisplay,
    children,
    ...props
  } = _ref;
  const [displayedView, setDisplayedView] = useState("MAIN");
  const {
    currentTheme
  } = useTheme();
  useEffect(() => {
    displayedView === "MAIN" && onMainOpened();
  }, [displayedView, onMainOpened]);
  useEffect(() => {
    if (forcedUIDDisplayed != null) {
      setDisplayedView(forcedUIDDisplayed);
      setForcedUIDisplay(null);
    }
  }, [forcedUIDDisplayed, setForcedUIDisplay]);
  const mapDisplayedViewWithComponent = uid => {
    var _currentTheme$theme;
    const _opt = options.filter(opt => opt.uid === uid)[0];
    const childrenRenderer = _opt === null || _opt === void 0 ? void 0 : _opt.children;
    console.log("_opt", _opt);
    return _opt && /*#__PURE__*/React__default.createElement(AppFadeView, null, isMainMenuBackVisible && /*#__PURE__*/React__default.createElement(AppText, {
      leftIcon: AppAssets.icons.navigationBack,
      isClickable: true,
      style: {
        fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.extra_small_font_size
      },
      onPress: () => {
        setDisplayedView("MAIN");
        (_opt === null || _opt === void 0 ? void 0 : _opt.onBack) && (_opt === null || _opt === void 0 ? void 0 : _opt.onBack(_opt));
      }
    }, "Back"), (_opt === null || _opt === void 0 ? void 0 : _opt.OptionMenuComponent) || /*#__PURE__*/React__default.createElement(DefaultOptionMenuComponent, {
      originalOption: _opt,
      childrenRenderer: childrenRenderer,
      onPress: item => onItemChange(item)
    }), _opt === null || _opt === void 0 ? void 0 : _opt.OptionMenuFooter);
  };
  const coreComponent = /*#__PURE__*/React__default.createElement(AppFadeView, props, displayedView === "MAIN" ? options === null || options === void 0 ? void 0 : options.map(opt => opt.isHidden !== true && /*#__PURE__*/React__default.createElement(OptionComponent, {
    item: opt,
    wrapperStyle: {
      paddingBottom: 5
    },
    isNavigation: opt === null || opt === void 0 ? void 0 : opt.isNavigation,
    navigationIcon: opt === null || opt === void 0 ? void 0 : opt.navigationIcon,
    icon: opt === null || opt === void 0 ? void 0 : opt.icon,
    onPress: () => {
      if (opt.subOptions) {
        setDisplayedView(opt.uid);
      }
      (opt === null || opt === void 0 ? void 0 : opt.onPress) && (opt === null || opt === void 0 ? void 0 : opt.onPress(opt));
      onOptionPressed && onOptionPressed(opt.uid, opt);
    },
    key: opt.uid
  }, opt.label)) : mapDisplayedViewWithComponent(displayedView));
  return shouldMenuProvideContext ? /*#__PURE__*/React__default.createElement(MenuProvider, {
    options: options,
    subOptions: subOptions,
    onChange: onChange
  }, children || coreComponent) : children || coreComponent;
};
AppMenuOptions.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppMenuOptions",
  "props": {
    "OptionComponent": {
      "defaultValue": {
        "value": "DefaultOptionComponent",
        "computed": true
      },
      "required": false
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "onItemChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "onMainOpened": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "shouldMenuProvideContext": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "isMainMenuBackVisible": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    }
  }
};

const CheckItem = _ref => {
  let {
    children,
    checked,
    setChecked,
    ...props
  } = _ref;
  return /*#__PURE__*/React__default.createElement(AppText, _extends({}, props, {
    style: {
      marginLeft: 10
    },
    onLeftIconPress: () => {
      setChecked && setChecked(!checked);
    },
    leftIcon: checked ? AppAssets.icons.check : AppAssets.icons.uncheck
  }), children);
};
CheckItem.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CheckItem",
  "props": {
    "children": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": ""
    },
    "checked": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "setChecked": {
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "(x: boolean) => void",
        "signature": {
          "arguments": [{
            "name": "x",
            "type": {
              "name": "boolean"
            }
          }],
          "return": {
            "name": "void"
          }
        }
      },
      "description": ""
    }
  }
};

const AppMultiSelectionOptions = _ref => {
  let {
    handleTick,
    listData,
    ...props
  } = _ref;
  return (listData === null || listData === void 0 ? void 0 : listData.length) > 0 ? /*#__PURE__*/React__default.createElement(AppList, {
    keyExtractor: "id",
    items: listData,
    contentContainerStyle: {
      padding: 10
    },
    renderItem: _ref2 => {
      let {
        item
      } = _ref2;
      return /*#__PURE__*/React__default.createElement(CheckItem, {
        wrapperStyle: {
          paddingVertical: 5
        },
        setChecked: () => handleTick(item, "checked"),
        checked: item.checked
      }, item.title);
    }
  }) : /*#__PURE__*/React__default.createElement(AppText, null, "No options available");
};
AppMultiSelectionOptions.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppMultiSelectionOptions"
};

export { AppMenuOptions as A, CheckItem as C, DefaultOptionMenuComponent as D, AppMultiSelectionOptions as a, DefaultOptionComponent as b };
